import Cookies from 'js-cookie'

const getLanguageCode = () => {

  return Cookies.get('language') || 'ru'
}

const getCurrencyCode = () => {

  return Cookies.get('currency') || 'RUB'
}

export { getLanguageCode, getCurrencyCode }